import React from 'react'
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
import {  Link } from 'react-router-dom'


const LoginForm = () => (
  <Grid textAlign='center' style={{ height: '90vh' }} verticalAlign='middle'>
    <Grid.Column style={{ maxWidth: 450 }}>
      <Header as='h2' color='instagram' textAlign='center'>
        <Image src='/images/logo.png' /> Log-in Quality Academics     
      </Header>
      <Form size='large'>
        <Segment stacked>
          <Form.Input fluid icon='user' iconPosition='left' placeholder='E-mail address' />
          <Form.Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Password'
            type='password'
          />

          <Button color='instagram' fluid size='large'>
            Login
          </Button>
        </Segment>
      </Form>
      <Message>
        Aun no eres miembro? <Link to="/registro" >Registrate</Link>
      </Message>
    </Grid.Column>
  </Grid>
)

export default LoginForm